// <newsletter-popup>: opens a few seconds after load (data-delay, in seconds), once per browser. Closing it (cross, or Escape when no other overlay is open) or subscribing
// sets jc-news-dismissed. After Shopify posts the form (data-posted) it opens at once with the status message and
// takes focus; only data-posted="success" counts as dismissed, an error leaves it free to come back. No backdrop, no focus trap, no scroll lock.
const KEY = "jc-news-dismissed";
const DEFAULT_DELAY = 4000;
// storage can throw (blocked cookies, private windows): then the popup shows once per page life
let dismissedInMemory = false;

function isDismissed() {
  if (dismissedInMemory) return true;
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

function dismiss() {
  dismissedInMemory = true;
  try {
    localStorage.setItem(KEY, "1");
  } catch {}
}

// Escape belongs to the topmost overlay: the mobile menu, the search panel, the cart drawer, the photo lightbox or an open dropdown
function overlayOpen() {
  return !!document.querySelector("[data-mmenu]:not([hidden]), [data-search-panel]:not([hidden]), cart-drawer .drawer.open, .lightbox, jc-select[open]");
}

class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    // connectedCallback runs again if the element is moved in the DOM: bind once
    if (this.ready) return;
    this.ready = true;
    this.querySelector("[data-close]").addEventListener("click", () => this.close());
    // capture phase: runs before the overlays' own Escape handlers, so it still sees them open
    document.addEventListener("keydown", e => {
      if (e.key === "Escape" && !this.hidden && !overlayOpen()) this.close();
    }, true);
    if ("posted" in this.dataset) {
      const ok = this.dataset.posted === "success";
      if (ok) dismiss();
      this.open();
      // success: the form is done, so focus goes to the close button; an error leaves the field ready to retry
      this.querySelector(ok ? "[data-close]" : ".field").focus({ preventScroll: true });
    } else if (!isDismissed()) {
      // data-delay is in seconds (a theme setting; 0 = right away)
      const seconds = parseFloat(this.dataset.delay);
      const delay = Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : DEFAULT_DELAY;
      this.timer = setTimeout(() => this.open(), delay);
    }
  }

  open() {
    if (dismissedInMemory && !("posted" in this.dataset)) return;
    this.hidden = false;
    // Shopify's hCaptcha badge (fixed, bottom right) appears once the form is touched and would cover the OK button:
    // newsletter.css lifts it above the popup by the popup's height, kept current here
    this.sizer ??= new ResizeObserver(() => document.documentElement.style.setProperty("--news-h", `${this.offsetHeight}px`));
    this.sizer.observe(this);
  }

  close() {
    clearTimeout(this.timer);
    this.hidden = true;
    this.sizer?.disconnect();
    dismiss();
  }
}

if (!customElements.get("newsletter-popup")) customElements.define("newsletter-popup", NewsletterPopup);
